var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"px-5",attrs:{"elevation":"0"}},[(_vm.isListView)?_c('DirectoryTable',{attrs:{"directories":_vm.directories,"readMeData":_vm.readMeData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }